import React from 'react';
import {clsx} from "clsx";

function ButtonLink({children, href, target, secondary, className, disabled}) {
    return (
        <a
            href={disabled ? '#' : href}
            target={target || '_self'}
            onClick={e => disabled && e.preventDefault()}
			className={clsx(
				secondary ? 'bg-red-500 hover:bg-red-400' : 'bg-[#0b5f82] hover:bg-[#0b7a9e]',
				'inline-flex items-center rounded-full px-5 py-2.5 text-center text-sm font-semibold text-white shadow-sm transform transition-all duration-200 ease-in-out hover:shadow-md hover:translate-y-[-1px] active:translate-y-[0px] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-500',
				className,
				disabled && '!bg-gray-400 cursor-not-allowed hover:translate-y-0 hover:shadow-sm'
			)}
        >
            {children}
        </a>
    );
}

export default ButtonLink;
